import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { CHANGE_PASSWORD } from '../../../../graphql/mutation/user/changePassword';
import { MY_ID } from '../../../../helpers/user/authorization';
import { MESSAGES } from '../../../../helpers/messages';
import useStyle from './changePassword.style';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { IconButton } from 'components/atoms/Buttons/IconButton';
import { LabelWithoutBG } from 'components/atoms/Label/Label.stories';
import { TextInput } from 'components/atoms/Inputs/TextInput';
import { Modal } from '../../Modals/Modal';
import { ErrorText } from 'components/atoms/Texts/ErrorText';
import toast from 'react-hot-toast';

const initState = {
  password: '',
  confirm: '',
  isValid: false,
  error: { message: '' }
};

export const ChangePassword = () => {
  const classes = useStyle();
  const [passwordHide, setpasswordHide] = useState(true);
  const [confirmHide, setConfirmHide] = useState(true);
  const [pass, setPass] = useState(initState);
  const [changePassword] = useMutation(CHANGE_PASSWORD, {
    onCompleted: () => {
      setPass(initState);
      toast.success('Votre mot de passe a bien été modifié');
    },
    onError: () => toast.error(MESSAGES.error.password)
  });

  const handleChange = e => {
    const field = e.target.name;
    const value = e.target.value;

    const validation = {
      correspondance:
        field === 'password' ? value === pass.confirm : value === pass.password,
      size: value.length >= 6,
      empty: value.length === 0
    };

    const newState = {
      ...pass,
      [field]: e.target.value,
      isValid: validation.correspondance && validation.size,
      error: {
        message: !validation.correspondance
          ? 'Les mots de passe ne correspondent pas'
          : validation.empty
          ? ''
          : !validation.size
          ? 'Le mot de passe doit contenir au moins 6 caractères'
          : ''
      }
    };
    setPass(newState);
  };

  return (
    <div className={classes.root}>
      <div className={classes.zones}>
        <div className={classes.zone}>
          <LabelWithoutBG text="Mot de passe" />
          <TextInput
            onChange={handleChange}
            value={pass.password || ''}
            placeHolder="ex: Mdp1234$..."
            name="password"
            type={passwordHide ? 'password' : 'text'}
            iconButton={
              <IconButton
                variant="backless"
                onClick={() => setpasswordHide(!passwordHide)}
                icon={passwordHide ? 'EyeOff' : 'EyeOn'}
                size="small"
              />
            }
          />
        </div>
        <div className={classes.zone}>
          <LabelWithoutBG text="Retaper le mot de passe" />
          <TextInput
            onChange={handleChange}
            value={pass.confirm || ''}
            placeHolder="ex: Mdp1234$..."
            name="confirm"
            type={confirmHide ? 'password' : 'text'}
            iconButton={
              <IconButton
                variant="backless"
                onClick={() => setConfirmHide(!confirmHide)}
                icon={confirmHide ? 'EyeOff' : 'EyeOn'}
                size="small"
              />
            }
          />
        </div>
      </div>
      {pass.confirm.length > 0 && <ErrorText text={pass.error.message} />}
      <div>
        <Modal
          modalHead={'Modifier votre mot de passe ?'}
          triggerButton={
            <ButtonWithText
              content="Changer de mot de passe"
              disabled={!pass.isValid}
              onClick={null}
            />
          }
          actionButton={
            <ButtonWithText
              content={'Oui je suis sûr(e)'}
              onClick={() =>
                changePassword({
                  variables: { pass: pass.password, id: MY_ID }
                })
              }
            />
          }
        >
          <p style={{ margin: 'auto' }}>
            Êtes vous sur de vouloir modifier votre mot de passe ?
          </p>
        </Modal>
      </div>
    </div>
  );
};
